import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { LOADING, IDLE } from "../../constants";
import { getActiveBuildingsByUserAccess } from "../../redux/core/buildings";
import { getAllActiveContacts } from "../../redux/core/contacts";
import { getAllOrganizations } from "../../redux/core/organizations";
import { getFromServerTopic } from "../../utility/slice";

const SLICE = "curtailmentContacts";

const action = (name) => `${SLICE}/${name}`;

export const getFromServer = (action, payloadFn) =>
  getFromServerTopic({ topic: SLICE, action, payloadFn });

export const getAllSiteContacts = getFromServer("getAllSiteContacts");

export const saveSiteContact = getFromServer(
  "saveSiteContact",
  async (payload) => payload,
);

export const getBuildings = createAsyncThunk(
  action("getActiveBuildingsByUserAccess"),
  async (payload, { dispatch, getState }) => {
    await dispatch(getActiveBuildingsByUserAccess());
    return getState().buildings;
  },
);

export const getOrganizations = createAsyncThunk(
  action("getAllOrganizations"),
  async (payload, { dispatch, getState }) => {
    await dispatch(getAllOrganizations());
    return getState().organizations;
  },
);

export const getMachContacts = createAsyncThunk(
  action("getAllActiveContacts"),
  async (payload, { dispatch, getState }) => {
    await dispatch(getAllActiveContacts());
    return getState().contacts;
  },
);

export const initializeCurtailmentContactsPage = createAsyncThunk(
  action("initializeCurtailmentContactsPage"),
  async (arg, { dispatch }) =>
    Promise.all([
      dispatch(getAllSiteContacts()),
      dispatch(getMachContacts()),
      dispatch(getBuildings()),
      dispatch(getOrganizations()),
    ]),
);

export const slice = createSlice({
  name: SLICE,
  initialState: {
    buildings: [],
    contacts: [],
    machContacts: [],
    organizations: [],
    status: LOADING,
  },
  reducers: {},
  extraReducers: (builder) =>
    builder
      .addCase(getAllSiteContacts.fulfilled, (state, action) => {
        state.contacts = action.payload.response;
      })
      .addCase(saveSiteContact.fulfilled, (state, action) => {
        const { contact, method } = action.payload.response;
        if (method === "save") {
          state.contacts = [
            ...state.contacts,
            { ...contact, siteContactId: action.payload.response.insertId },
          ];
        } else {
          state.contacts = [
            ...state.contacts.filter(
              (_contact) => _contact.siteContactId !== contact.siteContactId,
            ),
            contact,
          ];
        }
      })
      .addCase(getBuildings.fulfilled, (state, action) => {
        state.buildings = action.payload.buildings;
      })
      .addCase(getMachContacts.fulfilled, (state, action) => {
        state.machContacts = action.payload.activeContacts;
      })
      .addCase(getOrganizations.fulfilled, (state, action) => {
        state.organizations = action.payload.organizations;
      })
      .addCase(initializeCurtailmentContactsPage.pending, (state) => {
        state.status = LOADING;
      })
      .addCase(initializeCurtailmentContactsPage.fulfilled, (state) => {
        state.status = IDLE;
      }),
});

export default slice.reducer;
